// Where a reseller stands, as a badge: the reseller's own profile and the staff's list and
// reseller page show it the same way. The colour is the badge's own variant (CLAUDE.md, rule 6).
import type { ResellerStatus } from "@kilat/contracts/reseller";
import { Badge } from "@/components/ui/badge";
import { m } from "@/lib/paraglide/messages.js";

/** Each status's name on screen; the staff's status filter lists the same names. */
export const STATUS_LABELS: Record<ResellerStatus, () => string> = {
  pending: m.profile_status_pending,
  active: m.profile_status_active,
  suspended: m.profile_status_suspended,
  rejected: m.profile_status_rejected,
};

const VARIANTS: Record<ResellerStatus, "default" | "secondary" | "outline" | "destructive"> = {
  pending: "secondary",
  active: "default",
  suspended: "outline",
  rejected: "destructive",
};

export function ResellerStatusBadge({ status }: { status: ResellerStatus }) {
  return <Badge variant={VARIANTS[status]}>{STATUS_LABELS[status]()}</Badge>;
}
